export default function CTA() {
  return (
    <section className="t-sec t-sec--paper" aria-labelledby="close-title">
      <div className="t-wrap t-cta__grid">
        <div className="t-block-head">
          <h2 id="close-title" className="t-h2 t-rise">
            Tell me what is slowing the close.
          </h2>
          <p className="t-body t-para t-rise">
            I take on a small number of engagements at a time, so the first step is a conversation,
            not a checkout. You will get questions and an honest answer about whether this is worth
            doing, usually within one business day.
          </p>
        </div>

        <div className="t-cta__actions t-rise">
          <a className="t-btn" href="#contact">
            Ask about the pilot
          </a>
        </div>
      </div>
    </section>
  );
}
